import { createAction } from 'redux-starter-kit';
import api from 'api';
import { errHelper } from 'utils';

export const SET_POLICY = 'GET/Set-policy';
export const SET_RISK_SUMMARY = 'GET/risk-summaries';
export const CLEAN_STATE = 'CLEAN/portfolio-builder';
export const SET_CIP_TEMPLATE = 'SET/cip-template';
export const SET_CIP_FUNDS = 'SET/cip-funds';

const setPolicy = createAction(SET_POLICY);
const setRiskSummary = createAction(SET_RISK_SUMMARY);
const cleanState = createAction(CLEAN_STATE);
const setCipTemplate = createAction(SET_CIP_TEMPLATE);
const setCipFunds = createAction(SET_CIP_FUNDS);

export const portfolioBuilderActions = {
  cleanState,
  getPortfolioBuilderData:
    ({ portfolio, policyId }: { portfolio: any; policyId: any }) =>
    (dispatch: any) =>
      Promise.all([
        api.getPolicy({ portfolio, policyId }),
        api.getRiskSummaries({ portfolio }),
        api.getCipFunds(),
        api.getCipTemplate({ portfolio, policyId })
      ])
        .then(([policy, riskSummaries, cipFunds, cipTemplate]) => {
          dispatch(setPolicy(policy.data));
          dispatch(
            setRiskSummary(
              riskSummaries.data.results.length > 0
                ? riskSummaries.data.results[0]
                : []
            )
          );
          dispatch(setCipFunds(cipFunds.data));
          dispatch(setCipTemplate(cipTemplate.data));
        })

        .catch((err: any) => {
          errHelper(err);
        })
};
